import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ShowAds} from '../../../../global/util/enum/ShowAds';

@Component({
  selector: 'app-show-image-notice',
  templateUrl: './show-image-ads.component.html',
  styleUrls: ['./show-image-ads.component.css']
})
export class ShowImageAdsComponent implements OnInit {
  title: any;
  adsImage: any;
  newListAds: any[] = [];
  viewCheckOption: boolean;
  ads: any;
  dontShowAds: boolean;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

  accept() {
    this.activeModal.close(this.dontShowAds ? ShowAds.DONT_SHOW_ADS : ShowAds.SHOW_ADS);
  }

  getImageUrl(ads: any) {
    if (this.isPresentImage(ads)) {
      const imageOnBase64 = ads._more.adsImages[0];
      return 'data:' + imageOnBase64.extension + ';base64,' + imageOnBase64.image;
    }
  }

  getImages(ads: any) {
    return ads._more.adsImages;
  }

  isPresentImage(ads: any) {
    this.ads = ads;
    if (ads._more.adsImages.length > 0) {
      this.adsImage = ads._more.adsImages[0];
      return this.adsImage.image;
    }
    return false;
  }

  change(event: any) {
    if (event.target.checked) {
      this.dontShowAds = event.target.checked;
    } else {
      this.dontShowAds = false;
    }
  }

  navigateToUrl(ads: any): any {
    if (ads.link && ads.link !== 'null') {
      window.open(ads.link, '_blank');
    }
  }
}
